// JavaScript Document
import { Splide } from '/shared.js';


document.addEventListener('DOMContentLoaded', function () {

    const allLisWithChildren = document.querySelectorAll('li.menu-item-has-children > a');
    allLisWithChildren.forEach(function (a) {
        a.addEventListener('click', function (e) {

            e.preventDefault();
            this.closest('li.menu-item-has-children').classList.toggle('active');

        });

    });

    const allBlackish = document.querySelectorAll('.blackish');
    allBlackish.forEach(function (blackish) {
        blackish.addEventListener('click', function (e) {

            this.closest('li.menu-item-has-children').classList.remove('active');

        });

    });

    if (document.querySelector('.tests-splide')) {





        /**
        * Testimonials splide
        */
        const testimonialsSplide = new Splide('.tests-splide', {
            type: 'loop',
            focus: 'center',
            direction: 'rtl',
            autoWidth: true,

            gap: '4rem',
            updateOnMove: true,
            pagination: false,
            breakpoints: {
                1024: {
                    gap: '1rem',
                }
            }

        });
        testimonialsSplide.mount();

        //set .special-cursor-mover position according to mouse position uppon hovering splide next button

        const specialCursorMover = document.querySelector('.special-cursor-mover');
        const specialCursorRotator = document.querySelector('.special-cursor-rotator');
        const splideNext = document.querySelector('.splide__arrow--next');
        const splidePrev = document.querySelector('.splide__arrow--prev');
        const testArea = document.querySelector('.testimonials-area');


        const splideArrows = document.querySelectorAll('.splide__arrow--next, .splide__arrow--prev');

        testArea.addEventListener('mousemove', (e) => {
            const specialCursorSetX = e.pageX - specialCursorMover.clientWidth / 2;
            const specialCursorSetY = e.pageY - testArea.offsetTop - specialCursorMover.clientHeight / 2;
            // specialCursorMover.style.opacity = 1;
            specialCursorMover.style.transform = `translate3d(${specialCursorSetX}px, ${specialCursorSetY}px, 0)`;
        });
        splideArrows.forEach(arrow => {

            arrow.addEventListener('mouseout', () => {
                specialCursorRotator.style.opacity = 0;
                specialCursorRotator.style.transform = 'rotate(0)';
                specialCursorRotator.style.scale = '.3';

            });
        });

        splideNext.addEventListener('mouseenter', (e) => {
            specialCursorRotator.style.opacity = 1;
            specialCursorRotator.style.transform = 'rotate(-90deg)';
            specialCursorRotator.style.scale = '1';
        }
        );


        splidePrev.addEventListener('mouseenter', (e) => {
            specialCursorRotator.style.opacity = 1;
            specialCursorRotator.style.transform = 'rotate(90deg)';
            specialCursorRotator.style.scale = '1';

        }
        );

    }


})